import {
  cube,
  cubeOutline,
  home,
  homeOutline,
  list,
  listOutline,
  person,
  personOutline,
} from 'ionicons/icons';

import { NavItem } from '@core/interfaces';

export const MAIN_NAV_ITEMS: readonly NavItem[] = [
  { path: '/home', label: 'Home', icon: 'home-outline', activeIcon: 'home' },
  { path: '/actions', label: 'Actions', icon: 'list-outline', activeIcon: 'list' },
  {
    path: '/materials',
    label: 'Materials',
    icon: 'cube-outline',
    activeIcon: 'cube',
    feature: 'materials',
  },
  { path: '/profile', label: 'Profile', icon: 'person-outline', activeIcon: 'person' },
];

export const MAIN_NAV_ICONS = {
  home,
  homeOutline,
  list,
  listOutline,
  cube,
  cubeOutline,
  person,
  personOutline,
};
